import type { CCrmProjectManagementTranslations } from "./pl";

export const de: CCrmProjectManagementTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyOffer: "Derzeit sind keine Pakete zur Online-Bestellung verfügbar.",
  netto: "netto",
  brutto: "brutto",
  oneTime: "einmalig",
  recommended: "Empfohlen",
  priority: "Vorrangiger Support",
  formatTrial: (days) => `${days} Tage kostenlos testen`,
  formatPeriod: (period) => `/ ${period}`,

  orderCta: "Bestellen",
  orderBack: "Zurück zum Angebot",
  orderLoading: "Das Bestellformular wird geladen...",
  orderLoadFailed: "Das Bestellformular konnte nicht geladen werden.",
  orderSummaryPrice: "Zu zahlen",
  orderNoAccountTypes:
    "Die Online-Bestellung ist noch nicht konfiguriert - kontaktieren Sie uns, wir nehmen die Bestellung für Sie auf.",
  orderHaveAccount: "Ich habe bereits ein Konto - anmelden",
  orderLoginHide: "Ich fülle die Daten ohne Anmeldung aus",
  orderLoginField: "Login oder E-Mail-Adresse",
  orderPasswordField: "Passwort",
  orderLoginSubmit: "Anmelden",
  orderLoginFailed: "Die Anmeldung ist fehlgeschlagen.",
  orderLoginMfa:
    "Ihr Konto erfordert eine zusätzliche Anmeldebestätigung. Melden Sie sich auf der Kontoseite an und kehren Sie zur Bestellung zurück.",
  orderLoggedDataNote:
    "Diese Daten stammen aus Ihrem Konto. Korrigieren Sie sie, wenn auf der Rechnung andere stehen sollen - wir speichern sie mit der Bestellung.",
  orderAccountTypeLegend: "Ich bestelle als",
  orderAccountCompany: "Firma",
  orderAccountPrivate: "Privatperson",
  orderSectionContact: "Kontaktdaten",
  orderSectionCompany: "Firmendaten",
  orderSectionCompanyHint: "Diese Daten erscheinen auf der Rechnung für die Leistung.",
  orderSectionBilling: "Rechnungsdaten",
  orderProjectLegend: "Projekt",
  orderProjectNew: "- neues Projekt -",
  orderProjectHint:
    "Die Leistung wird dem gewählten Projekt zugeordnet. Wählen Sie ein neues Projekt, wenn es sich um einen separaten Auftrag handelt.",
  orderTrialHint:
    "Der Test startet die Leistung sofort, ohne Zahlung und ohne Rechnung. Nach dem Ende lässt sich die Leistung verlängern.",
  orderGusFetch: "Firmendaten anhand der USt-IdNr. aus dem Register laden",
  orderGusBusy: "Daten werden aus dem Register geladen...",
  orderGusFilled:
    "Firmendaten aus dem REGON-Register übernommen. Prüfen Sie sie vor dem Absenden.",
  orderGusNotFound: "Zu dieser USt-IdNr. wurde im REGON-Register keine Firma gefunden.",
  orderGusNipRequired: "Geben Sie eine USt-IdNr. ein, um die Daten aus dem Register zu laden.",
  orderSelectEmpty: "- auswählen -",
  orderDictionaryLoading: "Liste wird geladen...",
  orderDictionaryFailed: "Die Auswahlliste konnte nicht geladen werden.",
  orderRegulaminLegend: "Nutzungsbedingungen",
  orderRegulaminAccept: "Ich akzeptiere die Bedingungen der Leistung",
  orderRegulaminShow: "Bedingungen anzeigen",
  orderRegulaminHide: "Bedingungen ausblenden",
  orderRegulaminRequired: "Die Bestellung erfordert die Annahme der Bedingungen.",
  orderFieldRequired: "Dieses Feld ist erforderlich.",
  orderFieldInvalidUrl: "Geben Sie eine gültige Webadresse ein, z. B. https://ihrefirma.de",
  orderFieldExample: "Zum Beispiel:",
  orderFieldInvalidDate: "Geben Sie ein Datum im Format JJJJ-MM-TT ein.",
  orderFieldInvalidNumber: "Geben Sie eine Zahl ein.",
  orderFieldInvalidDigit: "Geben Sie eine ganze Zahl ohne Dezimalstellen ein.",
  orderFieldBelowMin: "Der Wert darf nicht kleiner als {min} sein.",
  orderFieldMinHint: "Mindestwert: {min}.",
  orderEmailRequired:
    "Geben Sie eine E-Mail-Adresse an - dorthin senden wir den Zugang zum Kundenpanel.",
  orderSubmitPaid: "Bestellen und zur Zahlung",
  orderSubmitFree: "Bestellen",
  orderSubmitTrial: "Kostenlosen Test starten",
  orderPaymentLink: "Zur Zahlung",
  orderPasswordEmail:
    "Wir haben ein Konto für Sie angelegt. An die angegebene Adresse ging ein Link zum Setzen des Passworts - danach können Sie sich im Kundenpanel anmelden.",
  formatOrderTitle: (name) => `Bestellung: ${name}`,
  formatOrderLoggedAs: (name) => `Sie bestellen als ${name}.`,
  formatOrderTrialHeading: (days) => `Sie können ${days} Tage kostenlos testen`,
  formatOrderTrialSummary: (days) => `Kostenloser Test: ${days} Tage, ohne Zahlung.`,
};
